import script from "./FreeVipTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./FreeVipTip.vue?vue&type=script&lang=ts&setup=true"

import "./FreeVipTip.vue?vue&type=style&index=0&id=90e522ca&lang=scss"

const __exports__ = script;

export default __exports__